import { useId } from 'react';
import PropTypes from 'prop-types';

import s from './textarea.module.css';

function Textarea({
  type = 'text',
  id,
  placeholder = '',
  value,
  onChange = () => {},
  autoCorrect = 'true',
  minLength = 0,
  maxLength = 1024,
  readOnly = false,
  disabled = false,
}) {
  const textareaId = useId();

  const handleChange = e => onChange(e.target.value);

  return (
    <label htmlFor={textareaId} className={s.label} id={id}>
      <textarea
        type={type}
        id={textareaId}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        readOnly={readOnly}
        autoCorrect={autoCorrect}
        minLength={minLength}
        maxLength={maxLength}
        disabled={disabled}
        className={s.textarea}
      />
    </label>
  );
}

export default Textarea;

Textarea.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.node,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  autoCorrect: PropTypes.string,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
};
